import { Injectable, signal } from '@angular/core'

@Injectable({
    providedIn: 'root'
})
export class ThemeService {
    private storageKey = 'darkMode'
    private _isDarkMode = signal(false)

    initializeTheme(): void {
        const saved = localStorage.getItem(this.storageKey)
        const prefersDark = window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches
        const useDark = false //saved !== null ? saved === 'true' : prefersDark
        const root = document.documentElement

        if (useDark) {
            root.classList.add('dark')
            this._isDarkMode.set(true)
        } else {
            root.classList.remove('dark')
            this._isDarkMode.set(false)
        }
    }

    toggleDarkMode(): void {
        const root = document.documentElement
        const isDark = root.classList.toggle('dark')
        localStorage.setItem(this.storageKey, String(isDark))
        this._isDarkMode.set(isDark)
    }

    isDarkMode(): boolean {
        return this._isDarkMode()
    }
}
